export const monthNames = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export function dateFormate(value: any) {
  const updated_on = new Date(value);
  // delete data.EffecDate;
  const update_date =
    updated_on.getDate() +
    "-" +
    monthNames[updated_on.getMonth()] +
    "-" +
    updated_on.getFullYear();

  return update_date;
}
